/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 土耳其语 国际化语言文件
 */
// 土耳其语.js
export default {
  centerAgent: {
    subagency: "Alt Ajans",
    search: "Ara",
    subagencyIncome: "Alt Ajans Geliri",
    last29Days: "Son 29 Gün",
    excludingToday: "Bugün Hariç",
    commission: "Komisyon",
    last30Days: "Son 30 Günün Verileri",
    rank: "Sıralama",
    hostNumber: "Ev Sahibi Sayısı",
    recent30Days: "Son 30 Günlük Ev Sahibi Geliri",
    commissionRate: "Komisyon Oranı",
    myCommission: "Komisyonum",
    remove: "Kaldır",
    thisAction:
      "Bu işlem, {hostoragent} {hostname}'ı ekibinizden kaldıracaktır. Devam etmek istediğinizi onaylıyor musunuz?",
    dashboard: "Gösterge Paneli",
    information: "Bilgi",
    dataCenter: "Veri Merkezi",
    hostList: "Ev Sahibi Listesi",
    bdList: "BD Listesi",
    agencyList: "Acente Listesi",
    myRight: "Yetkilerim",
    numberOf: "Acente Sayısı",
    inviteAgency: "Acente Davet Et",
    numberOfHost: "Ev Sahibi Sayısı",
    inviteHost: "Ev Sahibi Davet Et",
    inviteHostlinkcopied: "Davet bağlantısı kopyalandı",
    tipsShare: "İpuçları: Davetiye bağlantısını arkadaşlarınızla paylaşın",
    thisMonthD: "Bu Ayın Verileri",
    formDay1: "day1'dan day2'ye",
    hostGift: "Ev Sahibi Hediye Puanı",
    agentCommission: "Ajent Komisyonu",
    currentLevel: "Mevcut Seviye",
    commissionRateOf: "Ajan Gelir Komisyon Oranı",
    baseSalary: "Temel Maaş",
    stillNeed: "Hala ihtiyacım var",
    toReach: "ulaşmak için",
    reachedthe: "Reklam Görevi",
    advertisementTask: "Veri Genel Bakışı",
    dataOverview: "Veri Genel Bakışı",
    today: "Bugün",
    hostPoint: "Host Puanı",
    agentsPoints: "Ajan Puan Geliri",
    thisMonth: "Bu Ay",
    month: "Ay",
    lastMonth: "Geçen Ay",
    bdNumber: "BD Numarası",
    hostIncome: "Host Geliri",
    todayIncome: "Bugünkü Gelir",
    past30Days: "Son 30 Gün",
    host: "Ev Sahibi",
    country: "Ülke",
    level7: "Seviye / 7 Günlük Gelir",
    pointIncome: "Puan Geliri",
    liveDuration: "Canlı Süre",
    joinTime: "Katılma Zamanı",
    state: "Durum",
    operation: "İşlem",
    bd: "BD",
    totalHosts: "Toplam Host Geliri",
    totalAgents: "Toplam Ajan Geliri",
    agent: "Ajan",
    agentLevel: "Ajan Seviyesi / Komisyon Oranı",
    commissionIncome: "Komisyon Geliri",
    showDirect: "Sadece doğrudan ajanları göster. Bugünün verileri hariç",
    excludingTodayData: "Bugünün verileri hariç",
    packages: "Paketler",
    contents: "İçerikler",
    balance: "Baki",
    release: "Serbest Bırak",
    issue: "Yayınla",
    createBd: "BD Oluştur",
    times: "kez",
    authorizeCs: "CS Yetkisi Ver",
    giftTo: "Kullanıcıya Hediye Et",
    bdCreation: "Kalan BD Oluşturma Limiti",
    csAuthorization: "Kalan CS Yetki Kotası",
    giftName: "Hediye Adı",
    giftContents: "Hediye İçeriği",
    check: "Kontrol et",
    cancel: "İptal",
    tip: "Bahşiş",
    recipientsVip:
      "Alıcının VIP seviyesi hediye paketi limitini aşıyor. Bu hediyenin VIP avantajları devre dışı bırakılacak. Devam etmek istediğinizden emin misiniz?",
    confirm: "Onayla",
    authorize: "Yetki Ver",
    inviteBy: "Kullanıcı ID'si ile Davet Et",
    invite: "Davet Et",
    inviteLink: "Davet Bağlantısı",
    copy: "Kopyala",
    success: "Başarı",
    pleaseCheck: "Lütfen Kullanıcı ID'sini Kontrol Edin",
    totalGift:
      "Tüm Hostların Toplam Hediye Geliri (sıralama, görev gibi platform ödülleri hariç), alt ajansların hediye gelirlerini de içerir.",
    totalAgentsCom:
      "Ajanların host gelirlerinden aldığı toplam komisyon, alt ajanların komisyonlarını içerir.",
    allAgent: "Tüm Ajanlar",
    directAgent: "Doğrudan Ajan",
    indirectAgent: "Dolaylı Ajan",
    newUpgraded: "Yeni Yükseltilmiş Ajan",
    newS: "Yeni S Ajanları",
    newB: "Yeni B Ajanları",
    newC: "Yeni C Ajanları",
    expectedReward: "Beklenen Ödül",
    newA: "Yeni A Ajanları",
    agencyLevel: "Ajans Seviyesi",
    nickname: "Takma Ad",
    editNicknameTip:
      "Acente adınızı ayda bir ücretsiz olarak değiştirebilirsiniz",
    enterNewNickname: "Lütfen yeni bir takma ad girin",
    nicknameUpdateSuccess: "Takma ad başarıyla güncellendi",
    cannotEditNickname: "Takma Ad Düzenlenemez",
    cannotEditTip:
      "Takma adınızı sadece bir kez ücretsiz düzenleyebilirsiniz. Takma adınızı değiştirmek için lütfen müşteri desteği ile iletişime geçin.",
    alreadyChangedTip:
      "Bu ay ajans adınızı zaten değiştirdiniz. Ek değişiklikler 8.000 coin tutarındadır.",
    payAndSave: "Öde ve kaydet",
    upgradeDate: "Yükseltme Tarihi",
    bdPolicy: "BD Politikası",
    agencyDetail: "Ajans Detayı",
    agency: "Ajans",
    hostCommission: "Host Komisyonu",
    last6Days: "Son 6 Gün",
    giftIncome: "Hediye Geliri",
    mins: "dakika",
    agencyCenter: "Ajans Merkezi",
    myIncome: "Bugünkü Gelirim",
    totalHost: "Toplam Host Puanları",
    overview: "Genel Bakış",
    hostPoints: "Host Puanları",
    myHosts: "Host Puanlarım",
    subagentHost: "Alt Ajan Host Puanları",
    subagencyNumber: "Alt Ajans Sayısı",
    otherIncome: "Diğer Gelir",
    contactAdmin: "Admin ile İletişim",
    whatsapp: "WhatsApp",
    bdCenter: "BD Merkezi",
    copySuccess: "Kopyalama Başarılı",
    pleaseInput: "Lütfen şarj miktarını girin, minimum 10",
    agencyPolicy: "Ajans Politikası",
    agencyCommission: "Ajans Komisyonu",
    agencyCommission2:
      "Ajans Komisyonu = Komisyon Oranı × Tüm Hostların Toplam Hediye Geliri (sıralama, görev gibi platform ödülleri hariç)",
    excludingPlatform: "(sıralama, görev gibi platform ödülleri hariç)",
    agencyCommissionCalculation: "Ajans Komisyonu Hesaplama",
    level: "Seviye",
    pointsTarget: "Puan Hedefi (Son 30 Gün)",
    points10000: "10,000 Puan = 1 USD (M= milyon)",
    note1:
      "Not 1: Toplam Geçerli Gelir = Ajans geliriniz + Alt ajanslarınızın her kademesinin geliri",
    note2:
      "Not 2: Ajan komisyonları, host hediye aldığında gerçek zamanlı olarak tahsil edilecektir.",
    note3:
      "Not 3: Minimum çekilebilir tutar 10 USD'dir ve çekimler 10'un katları olmalıdır (örneğin: 10 USD, 20 USD, 30 USD).",
    subagencycommission: "Alt Ajans Komisyonu",
    theMain:
      "Ana ajans, alt ajansların her kademesinin (T1, T2, T3, T4, ... Tn) gelirlerinden komisyon kazanabilir, maksimum komisyon oranı %16'dır.",
    forExample: "Örneğin:",
    agencyA: "A Ajansı, B Ajansı ve C Ajansını davet eder.",
    agencyB: "B Ajansı, D Ajansı ve E Ajansını davet eder.",
    agencyC: "C Ajansı, F Ajansını davet eder.",
    noteFigures:
      "(Not: parantez içindeki rakamlar, her ajansın altındaki hostların gelirini temsil eder).",
    thusWe:
      "Böylece, A Ajansı'ndan F Ajansı'na kadar ajansların Toplam Geçerli Gelirini ve Komisyon Oranını hesaplayabiliriz.",
    totalValid:
      "Toplam Geçerli Gelir = Ajansınızın Geliri + Alt Ajansların Her Kademesinin Geliri",
    aTotal:
      "A Toplam Geçerli Gelir = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (%20 komisyon oranı)",
    bTotal:
      "B Toplam Geçerli Gelir = B + D + E = 20M + 20M + 30M = 70M (%16 komisyon oranı)",
    cTotal:
      "C Toplam Geçerli Gelir = C + F = 70M + 80M =150M (%20 komisyon oranı)",
    dTotal: "D Toplam Geçerli Gelir =20M (%12 komisyon oranı)",
    eTotal: "E Toplam Geçerli Gelir =30M (%12 komisyon oranı)",
    fTotal: "F Toplam Geçerli Gelir =80M (%16 komisyon oranı)",
    subagencyCommission:
      "Alt Ajans Komisyonu = (Ana ajans komisyon oranı - Alt ajans komisyon oranı) × Alt ajansın Toplam Geçerli Geliri",
    agencyAC: "{A} Ajansının {B} Ajansından Aldığı Komisyon",
    thereforeAgency:
      "Bu nedenle, {A} Ajansının alt ajanslardan aldığı toplam komisyon",
    sinceAgency:
      "D, E ve F Ajanslarının alt ajansı olmadığı için alt ajans komisyonu kazanamazlar.",
    seniorPolicy: "Üst Düzey Politika",
    nomore: "Daha Fazla Veri Yok",
    active: "Aktif",
    disabled: "Devre Dışı",
    deleted: "Silindi",
    lastLogintime: "Son Giriş Zamanı",
    onmic: "Bugün Mikrofon Açık",
  },
  sellerCoin: {
    detailsOf: "Para Çekme Detayları",
    fundsSent: "Fon Gönderildi",
    transfer: "Transfer",
    totalIncome: "Toplam Gelir",
    orderIncome: "Sipariş Geliri",
    estimatedReward: "Tahmini Ödül",
    amount: "Miktar",
    applicantId: "Başvuru Sahibi Kimliği",
    applicantName: "Başvuru Sahibi Adı",
    orderId: "Sipariş Kimliği",
    uploadScreenshot: "Ekran Görüntüsünü Yükle",
    ensureWithdrawal:
      "Çekimin başarılı olduğundan emin olun, ardından ekran görüntüsünü yükleyin ve başvuru sahibini bilgilendirmek için aşağıdaki düğmeyi tıklayın.",
    remain: "Kalan",
    pleasePay:
      "Lütfen hemen ödeme yapın ve makbuzu yükleyin. Zaman sınırını aşarsanız, siparişin ödeme uygunluğu iptal edilecektir.",
    youCan: "Günde 5.000'e kadar davet puanı kazanabilirsiniz",
    pleaseComplete: "Lütfen çekimi zamanında tamamlayın ",
    unableTo: "Ödeme Yapılamıyor, Reddet",
    notifyThe: "Başvuru Sahibini Bilgilendir",
    youCanGet:
      "Siparişleri zamanında işlerseniz %1-%3 ekstra bonus alabilirsiniz.",
    ifYou: "Siparişleri 30 dakika içinde işlerseniz %3 bonus alabilirsiniz.",
    egThe:
      "Örneğin: 90000 puan değerindeki bir sipariş, 30 dakika içinde işlerseniz, %3 bonus alabilirsiniz, yani 90000 × %3 = 2700 puan.",
    gotIt: "Anladım",
    pleaseUpload: "Lütfen resim yükleyin",
    detail: "Detay",
    balance: "Balance",
    exchange: "Takas",
    all: "Tümü",
    recharge: "Şarj et",
    official: "Resmi",
    exchangeDetail: "Takas Detayı",
    coinSeller: "Coin Satıcısı",
    levelUp: "Seviye Atla",
    currentLevel: "Mevcut Seviye",
    myBalance: "Bakiyem",
    details: "Detaylar",
    paymentMethod: "Ödeme yöntemi",
    myOrder: "Siparişim",
    paymentMenthod: "Ödeme Yöntemi",
    acceptingOrders: "Sipariş Kabul Ediyor",
    unavailable: "Müsait Değil",
    greetingMessage: "Karşılama Mesajı Ayarları",
    serviceUnavailable: "Hizmet Kullanılamıyor",
    thisFeature:
      "Bu özellik geçici olarak kilitlenmiştir. Yardım için müşteri desteği ile iletişime geçin.",
    editMessage: "Mesajı Düzenle",
    customizeYour:
      "Karşılama mesajınızı özelleştirin. Coin şarjı hakkında yararlı bilgiler ekleyebilirsiniz.",
    theMessage:
      "Yeni bir kullanıcı sizinle özel bir sohbet başlattığında mesaj otomatik olarak gönderilecektir",
    save: "Kaydet",
    pleaseEnterMessge: "Lütfen karşılama mesajınızı girin",
    salesMethod: "Satış Yöntemi",
    user: "Kullanıcı",
    coinseller: "Coin Satıcısı",
    userId: "Kullanıcı Kimliği",
    check: "Kontrol et",
    coinAmount: "Coin Miktarı",
    pleaseEnter: "Lütfen 1'in katını girin",
    enterAt: "En az 100 girin, 1'in katları olarak",
    transferDetails: "Transfer Detayları",
    recommendSeller: "Satıcıyı Öner",
    recent30Day: "Son 30 Günlük Coin Satışları",
    whatsapp: "WhatsApp",
    chat: "Sohbet",
    yourCountry: "Ülkenizde şu anda mevcut coin satıcısı yok.",
    pleaseContact: "Lütfen müşteri desteği ile iletişime geçin.",
    customerSupport: "müşteri desteği",
    contact: "İletişim",
    customRecharge: "Özel Şarj",
    rechargeDetails: "Şarj Detayları",
    myPoints: "Puanlarım",
    todayRemaining: "Bugün kalan kota",
    customExchange: "Özel Takas",
    exchangeDetails: "Takas Detayları",
    rechargeRules: "Şarj Kuralları",
    sellerLevel: "Satıcı Seviyesi",
    proportion: "Oran",
    levelRequirement: "Seviye Gereksinimi",
    beginner: "Başlangıç",
    singleRecharge: "Tek şarj",
    standard: "Standart",
    senior: "Kıdemli",
    exchangeRules: "Takas Kuralları",
    note: "Note",
    seniorCoin:
      "Kıdemli Satıcı, günlük olarak tam oranla en fazla {point} puan değiştirebilir. {point} sonrası:",
    beginnerSeller: "Başlangıç Satıcısı",
    standardSeller: "Standart Satıcı",
    seniorSeller: "Kıdemli Satıcı",
    cancel: "Cancel",
    pleaseInput: "Please input the recharge amount, minimum 10",
    pleaseInput2: "Lütfen şarj miktarını girin, 100K katları",
    confirmation: "Onay",
    userName: "Kullanıcı Adı",
    theUser: "Kullanıcı kara listeye alındı",
    enterAmount: "Miktarı girin",
    pleaseInput3: "Lütfen miktarı girin",
    theAmount: "Miktar 100000'in katı olmalı",
    pleaseInput4: "Lütfen miktarı girin veya seçin",
    pleaseSelect: "Lütfen satış yöntemini seçin",
    pleaseInput5: "Lütfen kullanıcı kimliğini girin",
    atLeast: "Aktarım için en az 100K jeton~",
    pleaseSelect2: "Lütfen ödeme yöntemini seçin",
    minimum: "minimum",
    theAmount3: "Miktar 1'in katı olmalı",
    lessThan: "100000'den küçük veya eşit",
    orders: "Siparişler",
    applicant: "Başvuru Sahibi",
    method: "Yöntem",
    withdrawTime: "Çekilme Zamanı",
    viewDetail: "Detayı Görüntüle",
    toBe: "Onay Bekliyor",
    toBePaid: "Ödenecek",
    toBeCompleted: "Tamamlanacak",
    completed: "Tamamlandı",
    abnormal: "Anormal",
    refused: "Refused",
    confirmationTimeout: "Onay zaman aşımı",
    paymentTimeout: "Ödeme zaman aşımı",
    binance: "Binance",
    scanThe: "Ödeme yapmak için QR kodunu tarayın",
    quantity: "Miktar",
    orderAmount: "Sipariş tutarı",
    date: "Tarih",
    payNow: "Şimdi Öde",
    payment: "Ödeme",
    pleasePay2: "Lütfen aşağıdaki şekilde ödeme yapın",
    chainName: "Zincir Adı",
    contractAddress: "Sözleşme Adresi",
    theAbove: "Yukarıdaki adres yalnızca bu şarj için geçerlidir",
    copy: "Copy",
    notice: "Bildirim",
    pleaseTransfer:
      "Lütfen Binance'ın ücretini karşılamak için Ekstra 1 USDT transfer edin. Bunu yapmamak, jeton şarjınızı geciktirebilir.",
    paymentsMust:
      "Ödemeler 0,5 saat içinde tamamlanmalıdır, aksi takdirde platform herhangi bir sorundan sorumlu olmayacaktır.",
    add: "Ekle",
    confirmTo: "Bu ödeme yöntemini silmeyi onaylayın",
    countryCurrency: "Ülke ve Para Birimi Türü",
    selectPayment: "Gönderebileceğiniz ödeme yöntemini seçin",
    coinsSeller: "Coin Satıcısı Kuralları",
    standrd: "Standart",
    salesMethods: "Satış Yöntemleri",
    coinsellerRules: "CoinSeller Kuralları",
    whenApplying:
      "Bir coin satıcısı statüsüne yükseltme başvurusunda bulunulduğunda, depozito gereksinimi yoktur, sadece coin satıcısı seviyesini yükseltmek için 1 kez şarj gerekir. Coin satıcısı pozisyonunuzdan istifa etmeyi seçerseniz, mevcut coin satıcısı rolünüz sona erecektir",
    youCanReplenish:
      "Hesabınızı doğrudan USDT, Epay veya başka bir coin satıcısı aracılığıyla doldurabilirsiniz",
    fraudulentActivities:
      "Hala platformu içinde dolandırıcılık faaliyetleri kesinlikle yasaktır.",
    anyViolations:
      "Herhangi bir ihlal, coin satıcısının hesabının feshedilmesiyle sonuçlanacaktır",
    allRights: "Tüm hakları Hala saklıdır.",
    transferDetail: "Transfer Detayı",
  },
  centerHost: {
    baseSalary: "Temel Maaş",
    invitation: "Davet",
    tasks: "Görevler",
    other: "Diğer",
    consume: "Tüketmek",
    giftIncome: "Gift Income",
    received: "Alındı",
    from: "-den",
    luckyGift: "Şanslı hediye",
    hostCenter: "Host Merkezi",
    noAgent: "Aracı yok",
    last7: "Son 7 gün",
    hourlyIncome: "Saatlik gelir",
    toReach: "to reach",
    rules: "Kurallar",
    pointsOverview: "Puanlara Genel Bakış",
    totalIncome: "Toplam Gelir",
    gifts: "hediyeler",
    workDetail: "İş Detayı",
    liveDuration: "Live Duration",
    mins: "mins",
    todaysLive: "Bugünün canlı kaydı",
    dailyStatistics: "Günlük İstatistikler",
    startTime: "Başlangıç zamanı",
    endTime: "Bitiş zamanı",
    duration: "Süre",
    points: "Puanlar",
    date: "Date",
    giftPoints: "Hediye puanları",
    removeBinding: "Bağlamayı Kaldır",
    thisAction2:
      "Bu işlem sizi {agentName}'den ayıracaktır. Lütfen bağlamayı kaldırmak istiyorsanız onaylayın",
  },
  bombRule: {
    afterThe:
      "Odadaki patlama değeri belirli bir miktara ulaştıktan sonra, hediye bombası odada belirecektir",
    oneCoins: "Odada alınan 1 jeton = 1 patlama değeri",
    itWill:
      "Gereksinimleri karşıladıktan sonra otomatik olarak patlayacak ve oda sahibi karşılık gelen altın jeton ödüllerini alacaktır",
  },
  descriptionLevel: {
    wealth: "Servet",
    charm: "Çekicilik",
    wealthValue: "Servet Değeri",
    charmValue: "Çekicilik Değeri",
    needTo: "Gerekiyor",
    send: "gönder",
    receive: "almak",
    forThe: "yükseltme için",
    theRich: "Zengin seviyesi, şarj ettiğiniz jetonlarla sayılır",
    theCharm: "Çekicilik seviyesi, aldığınız jeton sayısına göre hesaplanır",
    LevelLabel: "Seviye Etiketi",
    level: "Level",
    levelLogo: "Seviye Logosu",
  },
  gameRank: {
    gameRank: "Oyun Sıralaması",
    rules: "Rules",
    thisWeek: "Bu Hafta",
    lastWeek: "Geçen Hafta",
    agentGaming: "Ajan Oyun Geliri Sıralaması",
    rankingRewards: "Sıralama Ödülleri",
    rankingIs:
      "Sıralama, acente odası ve alt odalarındaki kullanıcıların toplam bahis cirosuna dayanmaktadır.",
    hostRoom: "Host Oda Geliri Sıralaması",
    rankingIs2:
      "Sıralama, ev sahibinin odasında üretilen toplam oyun gelirine dayanmaktadır",
    notes: "Notlar",
    eventDuration:
      "Etkinlik süresi: Her takvim haftası. Ödüller yalnızca şu durumlarda dağıtılır:",
    rewardsAre:
      "Rewards are distributed only if the corresponding revenue requirements are met.",
    allRewards:
      "All rewards will be issued within 1-2 working days after the event ends.",
    halaReserves: "Hala, bu etkinliğin nihai yorumlama hakkını saklı tutar",
    rewardsDetail: "Ödül Detayı",
    decorationsPreview: "Dekorasyon Önizleme",
  },
  gameLegacyHall: {
    surpriseLucky: "Sürpriz Şanslı Çanta",
    dailyPlayers:
      "Günlük oyuncular, rastgele jetonlar için ertesi gün bir Şanslı Çanta açabilir",
    eventRule: "Etkinlik Kuralı",
    usersSpending:
      "Kullanıcıların etkinlik oyunlarındaki harcamaları, sıralama puanlarına sayılacaktır",
    thePlatform:
      "Platform, her 4 saatte bir etkinlik oyunlarını döndürecek ve her dönüşte 4 farklı oyun yer alacak",
    theTop: "Günlük en iyi 3 oyuncu çerçeve ve jeton ödülleri alacak",
    theTop2: "Haftalık en iyi 10 oyuncu çerçeve ve jeton ödülleri alacak",
    usersWho:
      "Her gün etkinlik oyunlarına katılan kullanıcılar, rastgele miktarda jeton almak için ertesi gün bir şanslı çanta açabilir. Etkinlik oyunlarında ne kadar çok harcama yaparsanız, o kadar çok jeton alabilirsiniz",
    behindPrevious: "Öncekinin arkasında",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    countdown: "Geri sayım：",
    days: "günler",
    winOver: "Üzerinde kazan",
    coinsfrom: "bir günde oyunlardan jetonlar",
    earnOver: "Üzerinde kazan",
    coinsWitdh: "iade oranı kadar",
    fromOneDay: "bir günden itibaren",
    game: "Oyun",
    fromA: "tek bir bahisten",
    inthisWeek: "Bu Hafta İçinde",
    earnUp: "Kadar kazan",
    inAsingle: "tek bir günde",
    eventRules: "Etkinlik Kuralları",
    participateIn:
      "Yarın daha büyük bir şanslı çanta talep etmek için oyuna katılın",
    youDid:
      "Jeton ödülünü almadınız. Oyuna katılın ve yarın şanslı çantayı talep etmeye devam edebilirsiniz",
    participateIn2:
      "Oyuna katılın ve yarın şanslı çantayı talep etmeye devam edebilirsiniz",
    topDaily: "Günlük En İyi Coin Kazananı",
    topPayout: "En İyi Ödeme Oranı Kazananı",
    topCoins: "Haftalık Bir Turda En İyi Coin Kazananı",
    topPayout2: "Haftalık Bir Turda En İyi Ödeme Oranı Kazananı",
    topWeekly: "Haftalık En İyi Coin Kazananı",
    historicalTop: "Tarihteki En İyi Coin Kazananı Bir Günde",
    historicalTop2: "Tarihteki En İyi Ödeme Oranı Kazananı Bir Günde",
    historicalTop3: "Tarihteki En İyi Coin Kazananı Bir Turda",
    historicalTop4: "Tarihteki En İyi Ödeme Oranı Kazananı Bir Turda",
    historicalTop5: "Tarihteki En İyi Coin Kazananı Bir Haftada",
    gameReward: "Oyun Ödülü",
    usersSpending2:
      "Kullanıcıların etkinlik oyunlarındaki harcamaları, sıralama puanlarına sayılacaktır",
    theTop3: "Günlük en iyi 3 oyuncu çerçeve ve jeton ödülleri alacak",
    theTop4: "Haftalık en iyi 10 oyuncu çerçeve ve jeton ödülleri alacak",
    usersWho2:
      "Her gün etkinlik oyunlarına katılan kullanıcılar, rastgele miktarda jeton almak için ertesi gün bir şanslı çanta açabilir. Etkinlik oyunlarında ne kadar çok harcama yaparsanız, o kadar çok jeton alabilirsiniz",
    coins: "Madeni paralar",
    flameRider: "Alev Binicisi",
    sportCar: "Spor Araba",
    captainMeow: "Kaptan Meow",
    profileFrame: "Profil Çerçevesi",
  },
  gold: {
    coinsDetail: "Jeton Detayı",
    coinBalance: "Jeton Bakiyesi",
    all: "ALL",
    sendGifts: "Hediyeler Gönder",
    purchaseItems: "Öğeleri Satın Alın",
    games: "Oyunlar",
    exchange: "Exchange",
    recharge: "Recharge",
    activeReword: "Etkinlik Ödülleri",
  },
  integral: {
    all: "All",
    cashOut: "Nakit Çıkış",
    transfer: "Transfer",
    orderId: "Order ID",
    paymentMenthod: "Payment Menthod",
    withdrawalTime: "Çekilme Zamanı",
    pointsAmount: "Puan Miktarı",
    depositAmount: "Yatırım Miktarı",
    coinsAmount: "Jeton Miktarı",
    transferTo: "Transfer Et",
    normal: "Normal",
    pending: "Beklemede",
    success: "Success",
    failed: "Başarısız",
    points: "Points",
    pointsBalance: "Puan Bakiyesi",
    frozenPoints: "Dondurulmuş Puanlar",
    details: "Detaylar",
    exchange: "Exchange",
    currencyType: "Para Birimi Türü",
    paymentMethod: "Payment method",
    pointsAmount2: "Nakit çekme için puan miktarı",
    enterA: "100.000'in katını girin (minimum 200.000)",
    enterA2: "100000'in katını girin",
    accountInformation: "Hesap bilgileri",
    withdraw: "Çekmek",
    amount: "Amount",
    exchangeRate: "Döviz kuru",
    exchangePoints: "Takas Puanları",
    enterUserId: "Kullanıcı Kimliğini Girin",
    check: "Check",
    fee: "Ücret",
    theAgency: "Ajans alacak",
    transferFee: "Transfer ücreti: %2. Minimum transfer ≥ 100.000 puan.",
    clickTransfer:
      "İlgili puanları acentelerinize aktarmak için aktar düğmesine tıklayın",
    afterThe2:
      "Transfer tamamlandıktan sonra iptal edilemez veya geri çekilemez",
    transferPoints: "Transfer Puanları",
    recommendedMethod: "Önerilen Yöntem",
    lowerFees: "Daha düşük ücretler ve 24 saat içinde incelenir",
    paymentPassword: "Ödeme şifresi ayarlanmamış",
    cashOut2:
      "Nakit çıkış ve Takaslar, ödeme şifresi doğrulaması gerektirir. Lütfen önce ödeme şifrenizi ayarlayın.",
    cancel: "Cancel",
    goTo: "Ayarlara Git",
    youHave:
      "5 başarısız denemeye ulaştınız. Bir başarısız deneme daha hesabınızın dondurulmasına neden olacaktır. Şifrenizi unuttysanız, lütfen sıfırlayın.",
    inputIncorrect:
      "Yanlış şifreyi birçok kez girdiniz. Hesabınız donduruldu, lütfen sonra tekrar deneyin",
    verify: "doğrulamak",
    gotIt: "Got it",
    pointsInfo: "Puan Bilgisi",
    whenA:
      "Bir kullanıcı Google üzerinden şarj edilen Jetonları kullanarak size hediye gönderdiğinde, aldığınız puanlar kullanıma sunulmadan önce 7 gün boyunca dondurulacaktır. Kullanıcı iade talep ederse, bu puanlar kesilecektir. Lütfen platform kurallarına uyun ve herhangi bir ihlalden kaçının.",
    frozenPointsAre: "Dondurulmuş Puanlar, Toplam Puan Bakiyesine dahildir",
    theUser2: "Kullanıcı kara listeye alındı",
    successfulWithdrawal: "Başarılı Çekim",
    withdrawalAmount: "Çekim Miktarı",
    theFunds: "Fonlar 24 saat içinde ulaşacak",
    pleaseEnter2: "Lütfen şifreyi girin",
    passwordIncorrect: "Şifre yanlış",
    theAmount4: "Miktar 100000'in katı olmalı",
    pleaseEnter3: "Lütfen Kullanıcı Kimliğini girin",
    pleaseEnter4: "Lütfen doğru Kullanıcı Kimliğini girin",
    pleaseEnter5: "Lütfen miktarı girin",
    minimumTransfer: "Minimum transfer ≥ 100.000 puan",
    pleaseSelect3: "Lütfen yöntemi seçin",
    minimum: "minimum",
    theAmount5: "Miktar şundan az olmalı",
    illegalInput: "Yasadışı giriş",
    pleaseEnter6: "Lütfen Hesap bilgilerini girin",
  },
  invite: {
    inviteGame: "Oyun Kullanıcısını Davet Et",
    currentRebate: "Mevcut İndirim",
    need: "ihtiyaç",
    toProgress: "bir sonraki seviyeye ilerlemek için",
    gameReward: "Game Reward",
    referralData: "Yönlendirme Verileri",
    referralList: "Yönlendirme Listesi",
    date: "Date",
    gameBets: "Oyun Bahisleri",
    inviteRewards: "Davet Ödülleri",
    viewMore: "Daha Fazla Görüntüle",
    inviteFriends: "Arkadaşları Davet Et",
    myReward: "Ödülüm",
    totalRewards: "Toplam Ödüller",
    dailyReward: "Günlük Ödül",
    inviteRules: "Davet Kuralları",
    yourRebate:
      "İndirim Oranınız, son 30 gündeki Toplam Geçerli Bahislerinize bağlıdır",
    totalValid2:
      "Toplam Geçerli Bahisler = Kendi bahisleriniz + Davet ettiğiniz kullanıcıların her katmanının kendi bahisleri",
    rebateFrom:
      "Tier-1 davet edilen kullanıcılardan indirim = Kendi bahisleri × İndirim oranınız",
    rebateFrom2:
      "Tier-2 davet edilen kullanıcılardan indirim = Kendi bahisleri × (İndirim oranınız - Tier-1 indirim oranı)",
    ifThe:
      "Tier-2 davet edilen kullanıcı bir Tier-3 kullanıcıyı davet ederse, Toplam Geçerli Bahislerini artırabilir, ancak Tier-3'ten indirim alamaz.",
    example: "Örnek",
    tier1:
      "Tier-1 davet edilen - Sizin tarafınızdan doğrudan davet edilenlerden indirim nasıl hesaplanır?",
    asRebate:
      "A'nın B, C ve D'den indirimi = (B'nin Kendi Bahisleri + C'nin Kendi Bahisleri + D'nin Kendi Bahisleri) × A'nın İndirim Oranı =",
    bsRebate:
      "B'nin E ve F'den indirimi = (E'nin Kendi Bahisleri + F'nin Kendi Bahisleri) × B'nin İndirim Oranı =",
    csRebate:
      "C'nin G'den indirimi = G'nin Kendi Bahisleri × C'nin İndirim Oranı =",
    tier2:
      "Tier-2 davet edilen - Dolaylı olarak sizin tarafınızdan davet edilenlerden indirim nasıl hesaplanır?",
    asRebate2:
      "A'nın E ve F'den indirimi = (A'nın İndirim Oranı - B'nin İndirim Oranı) × (E'nin Kendi Bahisleri + F'nin Kendi Bahisleri) =",
    asRebate3:
      "A'nın G'den indirimi = (A'nın İndirim Oranı - C'nin İndirim Oranı) × G'nin Kendi Bahisleri =",
    myInvitation: "Davetim",
    search: "Search",
    invitationTime: "Davet Zamanı",
    inviteHost: "Invite Host",
    inviteA: "Bir Ev Sahibini Davet Edin, Her biri kadar",
    todayRewards: "Bugünün Ödülleri",
    rewardDetail: "Ödül Detayı",
    creatorRewards: "Yaratıcı Ödüller Cüzdanı",
    collect: "Topla",
    invitationDate: "Davet Tarihi",
    hostPolicy: "Ev Sahibi Politikası",
    halaReserves2:
      "Hala, yukarıdaki politikaların nihai yorumlama hakkını saklı tutar.",
  },
  listContribution: {
    contributiont: "Katkı",
    host: "Host",
    wealth: "Wealth",
    today: "Today",
    yesterday: "Dün",
    game: "Game",
    gift: "Hediye",
    hostEarnings: "Ev Sahibi Kazançları",
  },
  missionRule: {
    hostPolicy: "Host Policy",
    halaReserves3:
      "Hala, yukarıdaki politikaların nihai yorumlama hakkını saklı tutar",
  },
  purchase: {
    recharge: "Recharge",
    userId: "User ID",
    confirm: "Confirm",
    switchAccount: "Hesap değiştir",
    countryRegion: "Ülke/Bölge",
    officialAgency: "Resmi Ajans Şarjı",
    ttOff: "%20 indirim",
    totalAmount: "Toplam Tutar",
    purchase: "Satın al",
    pleaseComfirm: "lütfen Kullanıcı Kimliğini onaylayın",
    pleaseInput8: "Lütfen Kullanıcı Kimliğini girin",
    onlineService: "Çevrimiçi Hizmet",
    dealOf: "Son 30 Günün Anlaşması",
    recent30Day2: "Son 30 Günlük Coin Satışları",
    paymentMethod: "Payment Method",
    whatsapp: "WhatsApp",
    chat: "Chat",
    yourCountry2: "Ülkenizde şu anda mevcut coin satıcısı yok",
    pleaseContact2: "Lütfen müşteri desteği ile iletişime geçin.",
    customerSupport: "customer support",
    contact: "Contact",
  },
  roomGiftRule: {
    eventRules: "Event Rules",
    treasureChest:
      "Define sandığı ilerlemesi, odada hediye verilerek artırılır",
    whenThe:
      "Sandık anahtarının ilerleme çubuğu dolduğunda, define sandığı açılacaktır",
    afterThe3:
      ".3. ve 4. seviye define sandıkları gereksinimleri karşıladıktan sonra 1 dakika kilitlenir ve ardından otomatik olarak açılır",
    everyoneIn: "Odadaki herkesin hazine sandığındaki ödülleri alma şansı var",
    onceThe:
      "Hazine sandığı açıldıktan sonra, sistemin ödülü hesabınıza aktarması birkaç dakika sürebilir. Altın paralar bakiyenize, kostüm ise envanterinize eklenecektir.",
    theHigher:
      "Hazine sandığının seviyesi ne kadar yüksekse, içindeki ödüller de o kadar büyük olur",
    ifYou2:
      "Mevcut VIP seviyenizden daha düşük bir VIP seviyesiyle VIP olarak seçilirseniz, VIP seviyeniz geçerli olmayacaktır.",
    theProgress:
      "Sandık anahtarının ilerleme çubuğu her gün 00:00'da (UTC+5:30) sıfırlanacak",
  },
  share: {
    joinHala:
      "Hala'ya katılarak birden fazla kazanç fırsatının kilidini açın ve Ajanslar için özel avantajlardan ve ödüllerden yararlanın.",
    downloadTo: "Ortak Olmak İçin İndirin",
    joinHala2:
      "Eğlenceli oyunlar ve muhteşem ödüller kazanma şansı için Hala'ya katılın.",
    downloadAnd: "İndirin ve Kazanmaya Başlayın",
    joinHala3:
      "Hala'ya katılın ve hosting yolculuğunuza başlayın. Günlük 36$'a kadar bonus kazanın!",
    inviteYou: "Ajansa katılmaya davet ediyoruz",
    downloadNow: "Hosting'e Başlamak İçin Hemen İndirin",
    comeWith: "Hala'daki sohbet odasına katılmak için benimle gel",
    enthusiastsFrom:
      "Dünyanın dört bir yanından meraklılar paylaşmak için bir araya geliyor...",
    igniteEndless: "Sonsuz eğlenceyi ateşleyin",
    download: "İndirmek",
    halaLive: "Hala Canlı",
    showMe: "Bana Mutlu Dünyayı Göster",
    saySomething: "Bir şey söylemek...",
    downloadHala: "Hala Uygulamasını İndirin",
  },
  starHost: {
    starHost: "Yıldız Sunucu",
    level2: "Seviye {level} {days} gün boyunca korunur",
    currentSalary: "Mevcut Maaş",
    points: "Points",
    likes: "Beğeniler",
    stillNeed: "Still need",
    done: "Tamamlamak",
    numberOf2: "Hediye Verenlerin Sayısı",
    gifters: "Hediye verenler",
    gcoinGifts: "Gcoin Hediyeleri",
    gifts: "gifts",
    liveDuration: "Live Duration",
    min: "dakika",
    completeAll: "Yükseltmek için aşağıdaki görevlerin tümünü tamamlayın",
    follower: "Takipçi",
    numberOf3: "Hediye Verenlerin Sayısı",
    daysAt: "{level} Seviyesindeki Günler",
    giftCollection: "Hediye Koleksiyonu",
    gift: "Gift",
    date: "Date",
    expectedSalary: "Beklenen Maaş",
    gcoin: "Gcoin",
    status: "Durum",
    levelReached: " Seviyeye Ulaşıldı",
    notAchieved: "Başarılamadı",
    starHost2: "Yıldız sunucu kuralları",
    eachStar: "Her Star Host'un 3 günlük deneme süresi vardır",
    theyWill:
      "Yalnızca 3 gün boyunca A seviyesi standartlarını karşılarlarsa resmi Yıldız Sunucu olurlar",
    thoseWho: "Günlük A seviyesi hedeflerine ulaşamayanlar işten çıkarılacak",
    firedHosts: "Kovulan sunucular Yıldız Sunucu temel maaşını kazanamazlar",
    starHost3: "Yıldız Host temel maaşı haftalık olarak her Pazartesi ödenir",
    ifA:
      "Bir Yıldız Sunucu günlük görevleri tamamlayamazsa, saatlik maaşının yalnızca %50'sini alacaktır.",
    selfGifting:
      "Tüm hediye hedefleri için kendi kendine hediye verme kesinlikle yasaktır",
    starHost4: "Farklı Seviyelerde Yıldız Ev Sahibi Ödülleri",
    level: "Level",
    dailyExtra: "Günlük Ekstra Puan Ödülleri",
    liveBroadcast: "Canlı yayın süresi gerekli",
    starHost5: "Farklı seviyeler için Yıldız Sunucu Gereksinimi",
    requirements: "Gereksinim(ler)",
    yourApplication: "Başvurunuz resmi makamlarca onaylandı",
    stayOn: "7 gün boyunca A seviyesinde kalın",
    over1k: "1.000'den fazla hayran",
    totalGifter: "Toplam bağışçı sayısı > 300",
    receiveAll: 'Tüm "Şanslı" hediyeleri alın',
    everyLucky: "Her şanslı hediye sayısı 100'ün üzerinde olmalıdır",
    stayOn2: "10 gün boyunca S-Level'da kalın",
    over2k: "2 binden fazla hayran",
    totalGifter2: "Toplam bağışçı sayısı > 300",
    receiveAll2: 'Tüm "Sıcak" hediyeleri alın',
    stayOn3: "10 gün boyunca SS Seviyesinde kalın",
    over5k: "binden fazla hayran",
    totalGifter3: "Toplam bağışçı sayısı > 1000",
    receiveAll3: 'Tüm "Lüks" hediyeleri alın',
    starHost6: "Yıldız Sunucu Günlük Görevleri",
    dailyAssessment: "(Günlük Değerlendirme Sistemi): Etkileşim / Hediyeler",
    gcionGifts: "Gcion Hediyeleri",
    rulesTo: "Yıldız Ana Bilgisayar Seviyesini düşürme kuralları",
    failTo: "3 gün üst üste mevcut seviyenin standartlarını karşılayamamak.",
    failingTo: "Bir hafta içinde <span>3 kez standartları karşılayamamak",
    ifThe2:
      "Günlük gereksinimi karşılayamayan sunucu A seviyesindeyse, seviyesi düşürülmek yerine doğrudan işten atılır. Seviye düşürüldükten sonra, sunucunun seviyeyi yeniden kazanmak için 3 gün boyunca orijinal seviyenin standartlarını karşılaması gerekir.",
    involvementIn: "Büyük ihlallere veya olumsuz olaylara karışmak.",
    causingDamage: "Platformun çıkarlarına veya marka imajına zarar vermek",
    applyFor: "Kendi başınıza istifa başvurusunda bulunun",
    liveStreaming: "Canlı Yayın Gereksinimleri",
    liveStream:
      "Canlı yayın içeriği, sunucunun belirlediği türle uyumlu olmalıdır",
    roomHosts:
      "Oda sahiplerinin yayınlar sırasında mikrofonlarını uzun süre sessize almaları yasaktır",
    liveStreams:
      "Canlı yayınlar 9 kişilik mikrofon odası düzeni kullanılarak yapılmalıdır.",
    otherSeats:
      "Odadaki diğer koltukların, görev amaçlı mikrofonlarını sessize alan kullanıcılar veya izleyiciler tarafından işgal edilmesine izin verilmez.",
    discriminatoryInsulting:
      "Odada ayrımcı, hakaret içeren veya saldırgan ifadeler kesinlikle yasaktır.",
  },
  starRoom: {
    afterCountdown:
      "Her gün geri sayımdan sonra, En İyi 3 oda Yıldız Oda Sıralamasında listelenecektir",
    top20Star:
      "Bu haftadan sonra Top20 yıldızlı odalara bol bonus ödülü verilecek",
    countdown: "Countdown：",
    top3Daily:
      "Günlük en iyi 3 oda, haftalık yıldız odalarına katılmaya hak kazanacak",
    starRooms:
      "Yıldızlı odalar haftanın son gününde sıralanacaktır. Sıralama, her odanın toplam jeton akışına göre yapılacaktır.",
    top20Weekly:
      "Haftalık en iyi 20 yıldız odası sahipleri aşağıdaki ödülleri alacak:",
    qualificationTo:
      "Bu etkinliğe katılım için gerekenler: Odada herhangi bir ihlal veya yasa dışı davranışa izin verilmez, tespit edildiğinde hala odayı diskalifiye eder ve sıralamadan çıkarır.",
    theRewards: "Ödüller her pazartesi gönderilecektir.",
    days: "days",
    coins: "Coins",
  },
  inviteActive: {
    inviteHosts: "Ev Sahiplerini Davet Et",
    pointsMax: "Günlük maksimum 5.000 puan",
    firstRecharge: "İlk şarj kullanıcıları",
    get20: "20$ Ücretsiz Alın",
    oneInvite:
      "1. Davet ettiğiniz ev sahiplerinin yayını bittiğinde, ev sahiplerini canlı yayına davet edin.",
    aFinish: "a. Görev merkezinde yüz doğrulamayı tamamlayın",
    bCreate: "b.Kendi odasını yarat",
    cLive: "c.3 saat boyunca odasında mikrofon başında canlı yayın yaptı",
    dClaim: "d.Canlı ödülleri ilk kez talep edin",
    youGet:
      "Geçerli davetli ev sahibi numaralarınızdan her gün puan ödülleri kazanırsınız. Ödüllerinizi ertesi gün talep edebilirsiniz.",
    validHost: "Geçerli ana bilgisayar",
    pointsReward: "Puan Ödülü",
    youCan: " You can earn up to 5,000 invite points per day",
    myInvited: "Davetli ev sahiplerim",
    validHosts: "Bugünün Geçerli Ev Sahipleri",
    pointsRewards: "Puan Ödülleri",
    validHosts2: "Dün Geçerli Ev Sahipleri:",
    claim: "İddia",
    claimed: "İddia edildi",
    completedTime: "Tamamlanma Süresi",
    ifYour:
      "Arkadaşlarınızın ilk şarjını bitirmesi durumunda bol bol ödül kazanacaksınız. (Çevrimdışı şarj da dahil olacak).",
    theMore:
      "İlk yükleme tutarı ne kadar fazla olursa o kadar çok coin ödülü kazanırsınız ve günlük 20$'a kadar çıkabilir.",
    inviteesRecharge: "Davetliler Madeni Paraları Yeniden Yükle",
    yourReward: "Ödül Paralarınız",
    threeOnly:
      "3.Sadece 30 gün içerisinde kontör yüklemeye davet edilen kullanıcılar geçerli ilk kontör kullanıcısı olarak sayılacaktır.",
    seniorAnd:
      "Kıdemli ve standart satıcılar yalnızca uygulamadan veya resmi olarak doğrudan yükleme yaptıklarında (ödeme yöntemleri için yöneticinize başvurun) geçerli ilk yükleme kullanıcıları olarak sayılacaktır.",
    myInvited2: "Davet ettiğim Kullanıcılar",
    rechargeCoins: "Madeni paraları şarj edin",
    coinsRewards: "Madeni Para Ödülleri",
    firstRecharge2: "İlk yükleme coinleri dün:",
    firstRecharge3: "İlk Şarj Madeni Paraları",
    firstRecharge4: "İlk şarj süresi",
  },
  hostPolicy: {
    title: "Host Politikası",
    section1Title: "Yeni Hostların İlk Hafta Temel Maaşı",
    requirement: "Gereklilik",
    newHostsDesc: "İlk haftada Hala'ya katılan yeni hostlar",
    activeTime: "Mikrofon Aktif Süresi",
    oneHour: "1 Saat",
    twoHour: "2 Saat",
    threeHour: "3 Saat",
    baseSalary: "Temel Maaş (Puan)",
    incomeRequirement: "Gelir Gereksinimi",
    none: "Yok",
    remarks: "Notlar",
    remarksDesc:
      "Maksimum 3 saat/gün. Maksimum 7 gün. Toplam maksimum ödül 35.000 puan",
    note1:
      "Hostun kayıt tarihinden itibaren 7 günlük temel maaş geçerlilik süresi geri sayımı başlar.",
    note2:
      "Çoklu hesap kullanan veya çoklu IP veya cihazla giriş yapan hostlar temel maaş ödülünden diskalifiye edilecektir.",
    note3:
      "Eğer hostun son 7 gün geliri 150.000 puanın üzerindeyse, Yeni Host Temel Maaş Ödülü yerine Normal Host Saatlik Ödülü alacaktır.",
    section2Title: "Normal Host Eşit Ödül",
    level: "Seviye",
    incomeRequirementShort: "Gelir Gereksinimi",
    hourlyReward: "Saatlik Ödül",
    maximumDailyHours: "Maksimum Günlük Saat",
    section2Note1:
      "Mikrofonda sürekli 15 dakika etkili süre olarak sayılacaktır.",
    section2Note2:
      "Tüm ödüller puan olarak ödenir ve görev sistemi üzerinde talep edilmesi gerekir.",
    section2Note3: "Platform ödülleri puan gereksinimine sayılmayacaktır.",
    section2Note4:
      "Birden fazla IP veya cihaz tespit edildiğinde puanlar düşürülecektir.",
    section2Note5:
      "Son 7 gün, son 6 gün+bugün demektir, böylece daha yüksek puan seviyesine zamanında ulaştıkça saatlik ödülleriniz artabilir.",
    section2Note6:
      "L seviyesi hedef dışı ödülleri sadece kayıttan sonraki ilk 7 gün için geçerli olacaktır. 7 gün sonra, hostlar kalıcı olarak her gün 500 ücretsiz puan alabilir.",
    section3Title: "Host Yönetmelikleri",
    regulation1: "Hostların çoklu hesap kaydetmesi yasaktır.",
    regulation2: "Üçüncü taraf platformları tanıtmak yasaktır.",
    regulation3: "Reşit olmayanlar için kesinlikle yasaktır.",
    regulation4:
      "Bir hostun sadece bir doğrulanmış kimliği olabilir. Sadece doğrulanmış kimlikler canlı yayına başlayabilir ve kazanç çekebilir.",
    regulation5:
      "Canlı yayına başlamak veya kazanç çekmek için yüz kimliği doğrulamasını taklit etmek herhangi bir eylem kalıcı olarak yasaklanacaktır.",
    regulation6:
      "Canlı yayını için başkalarına kimlik sağlamak, kimliğin sistem tarafından kalıcı olarak yasaklanmasına neden olacaktır.",
    regulation7:
      "Sesli odada, hostlar odaya giren kullanıcılara aktif olarak selam vermelidir.",
    regulation8:
      "Sesli oda kapak fotoğrafı hostun gerçek, uyumlu bir fotoğrafını kullanmalıdır.",
    regulation9:
      "Hala platformu her türlü dolandırıcılık faaliyetini kesinlikle yasaklar. Herhangi bir ihlal kalıcı hesap askıya alma ile sonuçlanacaktır.",
    footer: "Hala yukarıdaki politikaların nihai yorum hakkını saklar.",
  },
  correspondingRevenue:
    "ilgili gelir gereksinimleri karşılanırsa. Tüm ödüller verilecektir",
  within12: "etkinlik bittikten sonra 1-2 iş günü içinde",
};
